import { Component, computed, input, ViewEncapsulation } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

type Appearance = 'primary' | 'accent' | 'warn' | 'error';

@Component({
  selector: 'rsr-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
  standalone: true,
  imports: [MatIcon],
  encapsulation: ViewEncapsulation.None
})
export class RsrBadgeComponent {
  variant = input<Appearance>('accent');
  hideIcon = input(false);

  $icon = computed(() => {
    if (this.hideIcon()) {
      return false;
    }

    switch(this.variant()) {
      case 'primary':
        return 'check';
      case 'accent':
        return 'info';
      case 'warn':
        return 'warning';
      case 'error':
        return 'error';
    }
  });
}
